export default __webpack_public_path__ + "static/media/7.68fe07ee.png";